// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s1AhZuFhul4GGt {
  padding: var(--ds-space-150, 10px);
  padding-left: var(--ds-space-200, 16px);
  background: linear-gradient(90deg, var(--ds-background-accent-purple-subtlest, #eae6ff) 0%, var(--ds-background-accent-green-subtlest, #e3fcef) 100%);
}
.fv_RG92MrW1ZmZ {
  display: flex;
  align-items: center;
  width: 100%;
  margin: var(--ds-space-0, 0);
}
.iNg31ygmQLypCe {
  display: flex;
  flex-shrink: 2;
  align-items: center;
}
.iNg31ygmQLypCe > img {
  width: 24px;
}
.iNg31ygmQLypCe > b {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 0.25rem;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 0.5rem;
}
.DJUCM6Tvre2fJM {
  flex-shrink: 2;
  padding-right: var(--ds-space-050, 4px);
  overflow: hidden;
  font-weight: var(--ds-font-weight-regular, normal);
}
.KgKBUJkl17ajKj {
  display: flex;
  flex-shrink: 0;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 1rem;
  margin-left: auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 0.5rem;
}
.xP7rFiaNCs27VG {
  margin-bottom: var(--ds-space-0, 0);
  background: var(--ds-background-neutral-bold-hovered, rgba(0, 0, 0, 0.8));
  color: var(--ds-text-inverse, #ffffff);
}
.xP7rFiaNCs27VG:hover,
.xP7rFiaNCs27VG:focus,
.xP7rFiaNCs27VG:active {
  background: var(--ds-background-neutral-bold, rgba(0, 0, 0, 0.7));
  color: var(--ds-text-inverse, #ffffff);
}
.wEn6H7nirRf1Pu {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-right: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `s1AhZuFhul4GGt`,
	"jwmBannerContents": `fv_RG92MrW1ZmZ`,
	"jwmBannerHeading": `iNg31ygmQLypCe`,
	"jwmBannerDesc": `DJUCM6Tvre2fJM`,
	"jwmBannerButtons": `KgKBUJkl17ajKj`,
	"jwmBannerPrimaryButton": `xP7rFiaNCs27VG`,
	"JWMLogoContainer": `wEn6H7nirRf1Pu`
};
export default ___CSS_LOADER_EXPORT___;
